import React from 'react'
import { Link } from 'react-router-dom'

interface CustomLinkProps{
  to:string,
  text:string,
  className?:string
}
const CustomLink = ({to,text, className}:CustomLinkProps) => {
  return (
    <span className={className}>
      <Link to={to}>{text}</Link>
    </span>
  )
}

export default CustomLink